import React from 'react';

import {AppFlags} from '../../../app/app-types';
import {connectAppEnv} from '../../../app/app-env';
import {frefFromRef} from '../../../lib/react/higher-order-components';
import {OEViewType} from '../../../lib/oe-types';
import OENotification from '../../../lib/notification/oe-notification';
import {OEWelcomeViewType, OEWelcomeViewProps} from './oe-welcome-view-model';
import OECambridgeCellWelcomeView from '../../custom/cell/oe-cambridge-cell-welcome-view';
import OEDisclaimerView from './oe-disclamer-view';
import OERegisterView from './oe-register-view';
import OEZeissUVWelcomeView from '../../custom/zeiss/oe-zeiss-uv-welcome-view';

export function OEWelcomeViewFactory(props) {
    let {fref, config, ...rest} = props;

    const openFn = (sender, isOpen) => {
        if(!props.appComponent || !props.appComponent.uiLayer) return;
        props.appComponent.uiLayer.notificationCenter.post(OENotification.viewOpenStateChanged, {
            type:       OEViewType.welcome,
            isOpen:     isOpen,
            sender:     sender
        });
    };

    if(config.type === OEWelcomeViewType.cambridgeCell)   {

        return <OECambridgeCellWelcomeView {...props} onOpenStateChanged={openFn}/>;

    } else if(config.type == OEWelcomeViewType.disclaimer)   {

        return <OEDisclaimerView {...props} onOpenStateChanged={openFn}/>

    } else if(config.type == OEWelcomeViewType.register)   {

        return <OERegisterView {...props} onOpenStateChanged={openFn}/>

    } else if(config.type == OEWelcomeViewType.zeissUV)   {

        return <OEZeissUVWelcomeView {...rest} config={config} ref={fref} onOpenStateChanged={openFn}/>
    }

    return null;
}

OEWelcomeViewFactory.defaultProps = OEWelcomeViewProps.defaultProps;

OEWelcomeViewFactory.propTypes = OEWelcomeViewProps.propTypes;

//
export default frefFromRef(connectAppEnv((env) => { return {
    appComponent:   env.component,
    config:         env.config.module.uiLayerConfig.welcomeView,
    devFeatures:    env.config.module.flags && env.config.module.flags.includes(AppFlags.import)
}})(OEWelcomeViewFactory));
